module.exports = __webpack_public_path__ + "static/media/MHSBGREEN.e13556a6.png";